import Vue from "vue";
import Vuex from "vuex";
import * as modules from "./modules";
import { isDevEnv } from "@/utils";
import vuexPersist from "@/plugins/vuex.persist.js";

const plugins = [vuexPersist.plugin]; //vuexSharedTabs

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  strict: isDevEnv(),
  devtools: isDevEnv(),
  plugins,
});
